import { NAME } from './constants';

export default {
  FETCH: `${NAME}/FETCH`,
  FETCHING: `${NAME}/FETCHING`,
  FETCHED: `${NAME}/FETCHED`,
  FAILED: `${NAME}/FAILED`,
  CREATE_BATCH: `${NAME}/CREATE_BATCH`,
  CREATED_BATCH: `${NAME}/CREATED_BATCH`,
  CREATE_PATCH_FAILED: `${NAME}/CREATE_PATCH_FAILED`,
};
